export const productCategoryList ="PRODUCT_CATEGORY_LIST";